import { Outlet } from "react-router-dom";
import AutoCompleteFirma from "../../components/autocomplete/AutoCompleteFirma";
import NavDropdown from "../../components/nav/NavDropdown";
import OpretFirma from "../../components/wizards/OpretFirma/OpretFirma";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../components/ErrorFallback";
import { useContext } from "react";
import { UserQueryContext } from "../../context/UserContext";
import AccessDenied from "../../components/AccessDenied";

export default function FirmaLayout() {
  const { user, hasPermission } = useContext(UserQueryContext);
  if (!hasPermission(user, "BasisRead")) return <AccessDenied />;
  return (
    <>
      <meta name="theme-color" content="#04606c" />
      <div className="l-main">
        <header className="navbar">
          <NavDropdown />
          <AutoCompleteFirma sizeLarge includeFirstItem={true} />
          {hasPermission(user, "BasisWrite") ? <OpretFirma /> : <div></div>}
        </header>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Outlet />
        </ErrorBoundary>
      </div>
    </>
  );
}
